import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemCongChuc extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.hoVaTen}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.nguoiDungCongChuc.email}</li>
            <li>{this.props.item.dienThoai}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.donViCongChuc.ten}</li>
            <li style={{fontStyle: 'italic'}}>{this.props.item.donViCongChuc.cha ? this.props.item.donViCongChuc.cha.ten : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.nguoiDungCongChuc && this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo ? this.props.item.nguoiDungCongChuc.vaiTroMacDinhInfo.ten : ''}</li>
          </ul>
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('CONGCHUC_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                  >
                  Chỉnh sửa
                </Link>
              : null
            }
            {
              CheckPermission('CONGCHUC_XOA') && this.props.item.congChucId != 1 ?
                <DeleteDialog
                  title="Xoá người dùng"
                  content="Bạn chắc chắn muốn xoá công chức này?"
                  redux={this.props.parent}
                  deleteId={this.props.item.congChucId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemCongChuc.jsx